<template>
    <div class="alert alert-warning">
        <h5 class="alert-heading">{{ Utils.capitalize($t("main.data_model_outdated")) }}</h5>
        <p class="mb-0">{{ $t("dialogs.data_model_outdated") }}</p>
    </div>
</template>
